import React from 'react';

import { CartPrice } from '@sharedComponents/Prices';
import { IBasicTestProps } from '@styles/model';
import { ReactFCV } from '@types';

export const FinalServicePrice: ReactFCV<
  {
    price: number;
    freePriceText: string | JSX.Element;
    isDualPriceLayout: boolean;
    isActive?: boolean;
  } & IBasicTestProps
> = ({
  price,
  freePriceText,
  isDualPriceLayout,
  isActive,
  ...props
  // eslint-disable-next-line react/jsx-no-useless-fragment
}) =>
  price ? (
    <CartPrice
      {...props}
      price={price}
      isActive={isActive}
      isDualPriceLayout={isDualPriceLayout}
      isColumnLayout={true}
    />
  ) : (
    // eslint-disable-next-line
    <div data-testid="free-service">{freePriceText}</div>
  );
